module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal1"
  }, [_c('i', [_vm._v("People are strange"), _c('br'), _vm._v("when you’re a stranger …")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('span', [_c('i', [_vm._v("—Jim Morrison")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal-c"
  }, [_c('i', [_vm._v("Under normal circumstances, sexual desires become stabilized as soon as they meet adequate satisfaction.… Freud describes a case in which the husband and wife had reached an exceptionally high level of perversion before they met (they had practiced every perversion in the book); it was a completely happy marriage, which ended only when the husband was arrested for the murder of a rich American woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "right3"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Colin Wilson")]), _vm._v(", Order of Assassins")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1086bb7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0